import type { PurchaseData } from '@/events/conversion';

import { BaseTracker } from './BaseTracker';
import type { TrackerFactory } from './TrackerFactory';

export class PurchaseTracker extends BaseTracker {
  constructor(factory: TrackerFactory) {
    super(factory);
  }

  track(data?: PurchaseData): void {
    if (!this.factory.isManualEnabled('purchase')) return;
    this.factory.dispatchManual('PURCHASE', data);
  }
}
